import localStorage from 'localStorage';

// Every game has its own player token. They are kept per game code, so being in several games
// (e.g. in different tabs) works, and old ones are dropped after a while.
const KEY = 'krazy-wordz-tokens';
const MAX_TOKENS = 30;

// Fallback for browsers that refuse to use localStorage
let tokensInMemory = {};

const read = () => {
    try {
        return JSON.parse(localStorage.read(KEY)) || tokensInMemory;
    } catch (error) {
        return tokensInMemory;
    }
};

const write = (tokens) => {
    tokensInMemory = tokens;
    localStorage.write(KEY, JSON.stringify(tokens));
};

export const getToken = (code) => (
    read()[code]?.token || null
);

export const setToken = (code, token) => {
    const tokens = Object.entries({ ...read(), [code]: { token, savedAt: Date.now() } })
        .sort(([, a], [, b]) => b.savedAt - a.savedAt)
        .slice(0, MAX_TOKENS);

    write(Object.fromEntries(tokens));
};

export const removeToken = (code) => {
    const { [code]: removed, ...tokens } = read();

    write(tokens);
};

export const generateToken = () => {
    const bytes = window.crypto.getRandomValues(new Uint8Array(24));

    return window.btoa(String.fromCharCode(...bytes))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};
